import React from "react";
import { Content } from "./Content";

/**
 * Wraps a route's element in the Content layout. Use with React Router v6 as:
 * <Route path="..." element={<ContentRoute component={Page} />} />
 */
export function ContentRoute({ children, component: Component, render }) {
  return (
    <Content>
      {Component != null ? <Component /> : children != null ? (typeof children === "function" ? children({}) : children) : render != null ? render({}) : null}
    </Content>
  );
}
